import { render, staticRenderFns } from "./AbilityList.vue?vue&type=template&id=4be96da5&scoped=true&"
import script from "./AbilityList.vue?vue&type=script&lang=js&"
export * from "./AbilityList.vue?vue&type=script&lang=js&"
import style0 from "./AbilityList.vue?vue&type=style&index=0&id=4be96da5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be96da5",
  null
  
)

export default component.exports